import React, { useState, useRef, useEffect } from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";
import "./Navbar.scss";
import "./NavbarPhone.scss";
import logo from "../Assets/Logo/LKI-full-logo.png";
import heart from "../Assets/Icons/Heart-icon.png";
import bagicon from "../Assets/Icons/bagicon.png";
import vegita from "../Assets/Logo/vegitaBlack.png";
import { useAppContext } from "../Components/AppProvider"; // ✅ import bag context
import { FaBaby, FaShoppingBag } from "react-icons/fa";

function Navbar() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");
  const [openDropdown, setOpenDropdown] = useState(null);
  const dropdownRef = useRef(null);
  const [categories, setCategories] = useState([]);
  const [activeMobileDropdown, setActiveMobileDropdown] = useState(null);

  const navigate = useNavigate();

  const {
    hasNewBagCount,
    setHasBagCount,
    customerId,
    setCustomerId,
    setUpdateOrderHistoryNav,
    hasWishlistCount,
    setHasWishlistCount,
    setIsLogin,
    setProfileChecker,
    profileChecker,
  } = useAppContext(); // ✅ grab bag count

  const [bagCount, setBagCount] = useState(0);
  const [wishlistCount, setWishlistCount] = useState(0);
  // ✅ fetch bag count from backend

  const handleDropdown = (idx) => {
    setOpenDropdown(openDropdown === idx ? null : idx);
  };
  const handleLogout = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/auth/logout`,
        {
          method: "POST",
          credentials: "include",
        },
      );
      const data = await res.json();
      if (data.success) {
        localStorage.clear();
        navigate("/login");
        setOpenDropdown(null);
        setCustomerId(null);
        setIsLogin(false);
      }
    } catch (err) {
      console.error("Logout failed:", err);
    }
  };
  // ✅ run on mount
  useEffect(() => {
    async function fetchBagCount() {
      try {
        // ⬇️ store the response in a variable
        const res = await fetch(
          `${process.env.REACT_APP_BASE_URL}api/bag/count/${customerId}`,
          {
            credentials: "include",
          },
        );

        if (!res.ok) {
          console.error("HTTP error:", res.status);
          setBagCount(0);
          return;
        }

        const data = await res.json();
        const bagCount = Number(data.bagCount);
        if (isNaN(bagCount)) {
          console.error("Invalid bagCount:", data.bagCount);
          setBagCount(0);
          return;
        }
        setBagCount(bagCount);

        //console.log("added Successfully", bagCount);
      } catch (err) {
        console.error("Failed to fetch bag count", err);
        setBagCount(0);
      }
    }
    async function fetchWishCount() {
      try {
        // ⬇️ store the response in a variable
        const res = await fetch(
          `${process.env.REACT_APP_BASE_URL}api/wishlist/get-wish-count-by-id/${customerId}`,
          {
            credentials: "include",
          },
        );

        if (!res.ok) {
          console.error("HTTP error:", res.status);
          setWishlistCount(0);
          return;
        }

        const data = await res.json();
        const wishlistCount = Number(data.wishlistCount);
        if (isNaN(wishlistCount)) {
          console.error("Invalid bagCount:", data.wishlistCount);
          setWishlistCount(0);
          return;
        }
        setWishlistCount(wishlistCount);

        //console.log("added Successfully", wishlistCount);
      } catch (err) {
        console.error("Failed to fetch bag count", err);
        setWishlistCount(0);
      }
    }
    if (customerId) {
      fetchBagCount(); // ✅ now it's defined
      fetchWishCount();
      setHasWishlistCount(false);
      setHasBagCount(false);
    }
  }, [hasNewBagCount, hasWishlistCount, customerId]);
  // Close dropdown on outside click
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropdown(null);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const fetchForeignData = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_BASE_URL}api/product/add-get-foreign`,
        );
        const data = await res.json();
        setCategories(data.categories);
      } catch (err) {
        console.error("Failed to fetch dropdown data", err);
      }
    };
    fetchForeignData();
  }, []);
  const HandleBagClick = () => {
    localStorage.setItem(
      "redirectAfterLogin",
      JSON.stringify({
        path: "/Bag",
      }),
    );
    navigate("/Bag");
  };
  const HandleProfileClick = () => {
    localStorage.setItem(
      "redirect",
      JSON.stringify({
        nav: 0,
        side: 0,
      }),
    );
    setUpdateOrderHistoryNav(true);
    navigate("/customer-profile");
    setOpenDropdown(null);
  };

  const HandleWishClick = () => {
    localStorage.setItem(
      "redirect",
      JSON.stringify({
        nav: 2,
        side: 0,
      }),
    );
    setUpdateOrderHistoryNav(true);
    navigate("/customer-profile");
  };
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);
  useEffect(() => {
    const redirect = localStorage.getItem("redirectAfterLogin");
    console.log("redirectAfterLogin:", redirect ? JSON.parse(redirect) : null);
  }, [location.pathname]);
  return (
    <>
      <nav className="navbar">
        <div className="main-container">
          <div className="container" ref={dropdownRef}>
            {/* Logo */}
            <div className="navbar-wrapper-logo">
              <Link to="/*">
                <img className="navbar-offset-logo" src={logo} alt="Logo" />
              </Link>
            </div>

            {/* Menu */}
            <ul className="navbar-menu">
              <li
                className="dropdown"
                onClick={() => {
                  handleDropdown(0);
                }}
                tabIndex={0}
              >
                PRODUCTS
                <span
                  className={`dropdown-arrow${
                    openDropdown === 0 ? " open" : ""
                  }`}
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill={openDropdown === 0 ? "black" : "none"}
                    stroke="black"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="6 9 12 15 18 9" />
                    <circle cx="12" cy="12" r="11" stroke="black" fill="none" />
                  </svg>
                </span>
                <ul
                  className="dropdown-menu"
                  style={{ display: openDropdown === 0 ? "block" : "none" }}
                >
                  <Link to="/products" state={{ catId: undefined }}>
                    <li>All Products</li>
                  </Link>

                  {categories.map((item) => (
                    <Link to="/products" state={{ catId: item.PC_ID }}>
                      <li key={item.PC_ID}>{item.PC_Name}</li>
                    </Link>
                  ))}
                </ul>
              </li>
              <li
                className="dropdown"
                onClick={() => {
                  handleDropdown(1);
                }}
                tabIndex={0}
              >
                ORDER GUIDELINES
                <span
                  className={`dropdown-arrow${
                    openDropdown === 1 ? " open" : ""
                  }`}
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill={openDropdown === 1 ? "black" : "none"}
                    stroke="black"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="6 9 12 15 18 9" />
                    <circle cx="12" cy="12" r="11" stroke="black" fill="none" />
                  </svg>
                </span>
                <ul
                  className="dropdown-menu"
                  style={{ display: openDropdown === 1 ? "block" : "none" }}
                >
                  <li
                    onClick={() => {
                      navigate("/guidelines", {
                        state: { section: "preorder" },
                      });
                      setOpenDropdown(null);
                    }}
                  >
                    Pre Order
                  </li>
                  <li
                    onClick={() => {
                      navigate("/guidelines", {
                        state: { section: "item-condition" },
                      });
                      setOpenDropdown(null);
                    }}
                  >
                    Item Condition
                  </li>
                  <li
                    onClick={() => {
                      navigate("/guidelines", {
                        state: { section: "downpayment" },
                      });
                      setOpenDropdown(null);
                    }}
                  >
                    Downpayment
                  </li>
                  <li
                    onClick={() => {
                      navigate("/guidelines", {
                        state: { section: "estemated-arival" },
                      });
                      setOpenDropdown(null);
                    }}
                  >
                    Estimated Time of Arrival (ETA)
                  </li>
                  <li
                    onClick={() => {
                      navigate("/guidelines", {
                        state: { section: "delay" },
                      });
                      setOpenDropdown(null);
                    }}
                  >
                    Delays
                  </li>
                  <li
                    onClick={() => {
                      navigate("/guidelines", {
                        state: { section: "balance" },
                      });
                      setOpenDropdown(null);
                    }}
                  >
                    Balance
                  </li>
                  <li
                    onClick={() => {
                      navigate("/guidelines", {
                        state: { section: "joy-dibbing" },
                      });
                      setOpenDropdown(null);
                    }}
                  >
                    Joy Dibbing
                  </li>
                  <li
                    onClick={() => {
                      navigate("/guidelines", {
                        state: { section: "cancellation" },
                      });
                      setOpenDropdown(null);
                    }}
                  >
                    Order Cancellation
                  </li>
                  <li
                    onClick={() => {
                      navigate("/guidelines", {
                        state: { section: "returns" },
                      });
                      setOpenDropdown(null);
                    }}
                  >
                    Returns
                  </li>
                  <li
                    onClick={() => {
                      navigate("/guidelines", {
                        state: { section: "item-claiming" },
                      });
                      setOpenDropdown(null);
                    }}
                  >
                    Item Claiming (Arrived Items)
                  </li>
                  <li
                    onClick={() => {
                      navigate("/guidelines", {
                        state: { section: "delivery-shipment" },
                      });
                      setOpenDropdown(null);
                    }}
                  >
                    Delivery/Shipment
                  </li>
                  <li
                    onClick={() => {
                      navigate("/guidelines", {
                        state: { section: "mode-of-payment" },
                      });
                      setOpenDropdown(null);
                    }}
                  >
                    Mode of Payment
                  </li>
                </ul>
              </li>
              <li
                className="dropdown"
                onClick={() => {
                  handleDropdown(2);
                }}
                tabIndex={0}
              >
                LEARNMORE
                <span
                  className={`dropdown-arrow${
                    openDropdown === 2 ? " open" : ""
                  }`}
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill={openDropdown === 2 ? "black" : "none"}
                    stroke="black"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="6 9 12 15 18 9" />
                    <circle cx="12" cy="12" r="11" stroke="black" fill="none" />
                  </svg>
                </span>
                <ul
                  className="dropdown-menu"
                  style={{ display: openDropdown === 2 ? "block" : "none" }}
                >
                  {" "}
                  <li
                    onClick={() => {
                      navigate("/learnmore", {
                        state: { section: "aboutus" },
                      });
                      setOpenDropdown(null);
                    }}
                  >
                    About Us
                  </li>
                  <li
                    onClick={() => {
                      navigate("/learnmore", {
                        state: { section: "contactus" },
                      });
                      setOpenDropdown(null);
                    }}
                  >
                    Contact Us
                  </li>
                </ul>
              </li>
            </ul>

            {/* Search 
        <div className="navbar-search">
          <input type="text" placeholder="SEARCH..." />
        </div>*/}

            {/* Icons */}
            <div className="navbar-icons-wrapper">
              <div className="icon-wrapper" onClick={HandleWishClick}>
                <img className="wishlist" src={heart} alt="Wishlist" />
                {/* 🔹 wishlist badge will go here */}{" "}
                <div className="badge-wrapper-wish">
                  {wishlistCount > 0 && (
                    <span className="icon-badge">{wishlistCount}</span>
                  )}
                </div>
              </div>
              <div className="icon-wrapper" onClick={HandleBagClick}>
                <img className="bagicon" src={bagicon} alt="Cart" />

                <div className="badge-wrapper">
                  {bagCount > 0 && (
                    <span className="icon-badge">{bagCount}</span>
                  )}
                </div>
              </div>
              <div className="icon-wrapper profile-wrapper">
                <img
                  className={`profile ${!customerId ? "disabled" : ""}`}
                  src={vegita}
                  alt="Profile"
                  onClick={() => {
                    if (!customerId) navigate("/customer-profile"); // ❌ do nothing if not logged in
                    setOpenDropdown(
                      openDropdown === "profile" ? null : "profile",
                    );
                  }}
                />

                {/* Show dropdown only when logged in */}
                {customerId && openDropdown === "profile" && (
                  <ul className="profile-dropdown">
                    <li onClick={HandleProfileClick}>MY PROFILE</li>
                    <li
                      onClick={() => {
                        localStorage.setItem(
                          "redirect",
                          JSON.stringify({
                            nav: 1,
                            side: 0,
                          }),
                        );
                        setUpdateOrderHistoryNav(true);
                        navigate("/customer-profile");
                        setOpenDropdown(null);
                      }}
                    >
                      Order History
                    </li>
                    <li
                      onClick={() => {
                        handleLogout();
                      }}
                    >
                      LOGOUT
                    </li>
                  </ul>
                )}
              </div>{" "}
              <div className="icon-wrapper">
                <div className="icon-wrapper mobile-menu" onClick={toggleMenu}>
                  <span className={`bar top ${isOpen ? "open" : ""}`}></span>
                  <span className={`bar middle ${isOpen ? "open" : ""}`}></span>
                  <span className={`bar bottom ${isOpen ? "open" : ""}`}></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* ⭐ Mobile Menu Modal */}
        {isOpen && (
          <div className="mobile-modal-overlay" onClick={toggleMenu}>
            <div className="mobile-modal" onClick={(e) => e.stopPropagation()}>
              <div className="mobile-modal-header">
                <h2></h2>
                <button className="close-btn" onClick={toggleMenu}>
                  ×
                </button>
              </div>

              <ul className="mobile-modal-links">
                {/* ⭐ PRODUCTS collapsible */}
                <li
                  className="collapsible"
                  onClick={() =>
                    setActiveMobileDropdown(
                      activeMobileDropdown === "products" ? null : "products",
                    )
                  }
                >
                  PRODUCTS
                  <span
                    className={`mobile-arrow ${
                      activeMobileDropdown === "products" ? "open" : ""
                    }`}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24">
                      <path
                        d="M6 9l6 6 6-6"
                        stroke="black"
                        strokeWidth="2"
                        fill="none"
                      />
                    </svg>
                  </span>
                </li>

                {activeMobileDropdown === "products" && (
                  <ul className="sub-links">
                    <li onClick={() => navigate("/products")}>All PRODUCT</li>

                    {categories.map((cat) => (
                      <li
                        key={cat.PC_ID}
                        onClick={() =>
                          navigate("/products", { state: { catId: cat.PC_ID } })
                        }
                      >
                        {cat.PC_Name}
                      </li>
                    ))}
                  </ul>
                )}

                {/* ⭐ ORDER GUIDELINES collapsible */}
                <li
                  className="collapsible"
                  onClick={() =>
                    setActiveMobileDropdown(
                      activeMobileDropdown === "guidelines"
                        ? null
                        : "guidelines",
                    )
                  }
                >
                  ORDER GUIDELINES
                  <span
                    className={`mobile-arrow ${
                      activeMobileDropdown === "guidelines" ? "open" : ""
                    }`}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24">
                      <path
                        d="M6 9l6 6 6-6"
                        stroke="black"
                        strokeWidth="2"
                        fill="none"
                      />
                    </svg>
                  </span>
                </li>

                {activeMobileDropdown === "guidelines" && (
                  <ul className="sub-links">
                    <li
                      onClick={() => {
                        navigate("/guidelines", {
                          state: { section: "preorder" },
                        });
                        toggleMenu();
                      }}
                    >
                      PRE ORDER
                    </li>
                    <li
                      onClick={() => {
                        navigate("/guidelines", {
                          state: { section: "item-condition" },
                        });
                        toggleMenu();
                      }}
                    >
                      ITEM CONDITIONS
                    </li>
                    <li
                      onClick={() => {
                        navigate("/guidelines", {
                          state: { section: "downpayment" },
                        });
                        toggleMenu();
                      }}
                    >
                      DOWNPAYMENT
                    </li>
                    <li
                      onClick={() => {
                        navigate("/guidelines", {
                          state: { section: "estemated-arival" },
                        });
                        toggleMenu();
                      }}
                    >
                      ETA
                    </li>
                    <li
                      onClick={() => {
                        navigate("/guidelines", {
                          state: { section: "delay" },
                        });
                        toggleMenu();
                      }}
                    >
                      DELAY
                    </li>
                    <li
                      onClick={() => {
                        navigate("/guidelines", {
                          state: { section: "balance" },
                        });
                        toggleMenu();
                      }}
                    >
                      BALANCE
                    </li>
                    <li
                      onClick={() => {
                        navigate("/guidelines", {
                          state: { section: "joy-dibbing" },
                        });
                        toggleMenu();
                      }}
                    >
                      JOY DIBBING
                    </li>
                    <li
                      onClick={() => {
                        navigate("/guidelines", {
                          state: { section: "cancellation" },
                        });
                        toggleMenu();
                      }}
                    >
                      ORDER CANCELLATION
                    </li>
                    <li
                      onClick={() => {
                        navigate("/guidelines", {
                          state: { section: "returns" },
                        });
                        toggleMenu();
                      }}
                    >
                      RETURNS
                    </li>
                    <li
                      onClick={() => {
                        navigate("/guidelines", {
                          state: { section: "item-claiming" },
                        });
                        toggleMenu();
                      }}
                    >
                      ITEM CLAIMING
                    </li>
                    <li
                      onClick={() => {
                        navigate("/guidelines", {
                          state: { section: "delivery-shipment" },
                        });
                        toggleMenu();
                      }}
                    >
                      DELIVERY
                    </li>
                    <li
                      onClick={() => {
                        navigate("/guidelines", {
                          state: { section: "mode-of-payment" },
                        });
                        toggleMenu();
                      }}
                    >
                      MODE OF PAYMENTS
                    </li>
                  </ul>
                )}
                {/* ⭐ LEARN MORE collapsible */}
                <li
                  className="collapsible"
                  onClick={() =>
                    setActiveMobileDropdown(
                      activeMobileDropdown === "learnmore" ? null : "learnmore",
                    )
                  }
                >
                  LEARN MORE
                  <span
                    className={`mobile-arrow ${
                      activeMobileDropdown === "learnmore" ? "open" : ""
                    }`}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24">
                      <path
                        d="M6 9l6 6 6-6"
                        stroke="black"
                        strokeWidth="2"
                        fill="none"
                      />
                    </svg>
                  </span>
                </li>

                {activeMobileDropdown === "learnmore" && (
                  <ul className="sub-links">
                    {" "}
                    <li
                      onClick={() => {
                        navigate("/learnmore", {
                          state: { section: "aboutus" },
                        });
                        setOpenDropdown(null);
                      }}
                    >
                      ABOUT US
                    </li>
                    <li
                      onClick={() => {
                        navigate("/learnmore", {
                          state: { section: "contactus" },
                        });
                        setOpenDropdown(null);
                      }}
                    >
                      CONTACT US
                    </li>
                  </ul>
                )}

                {/* ⭐ If user is logged in */}
                {customerId && (
                  <>
                    <li onClick={HandleProfileClick}>MY PROFILE</li>
                    {/** 
                  <li onClick={HandleWishClick}>Wishlist</li>
                  <li onClick={HandleBagClick}>My Bag</li>*/}
                    <li onClick={handleLogout}>LOGOUT</li>
                  </>
                )}

                {/* ⭐ If NOT logged in */}
                {!customerId && (
                  <li onClick={() => navigate("/login")}>LOGIN</li>
                )}
              </ul>
            </div>
          </div>
        )}
      </nav>
    </>
  );
}

export default Navbar;
